(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goneruna-placement-carousel"] && !Shopify.designMode) return;
  try {
    
  function moveGoneRunaPlacement(carousel, direction) {
    const maximum = carousel.scrollWidth - carousel.clientWidth;
    if (direction > 0 && carousel.scrollLeft >= maximum - 2) {
      carousel.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }
    if (direction < 0 && carousel.scrollLeft <= 2) {
      carousel.scrollTo({ left: maximum, behavior: 'smooth' });
      return;
    }
    carousel.scrollBy({ left: carousel.clientWidth * direction, behavior: 'smooth' });
  }

  function startGoneRunaPlacement(carousel) {
    if (!carousel || carousel.dataset.grPlacementReady === 'true') return;
    carousel.dataset.grPlacementReady = 'true';
    let timer;
    const schedule = function() {
      window.clearInterval(timer);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(function() { moveGoneRunaPlacement(carousel, 1); }, 4800);
    };
    ['pointerdown', 'touchstart', 'focusin', 'mouseenter'].forEach(function(name) {
      carousel.addEventListener(name, function() { window.clearInterval(timer); }, { passive: true });
    });
    ['pointerup', 'touchend', 'focusout', 'mouseleave'].forEach(function(name) {
      carousel.addEventListener(name, schedule, { passive: true });
    });
    schedule();
  }

  document.addEventListener('click', function(event) {
    const control = event.target.closest('[data-gr-placement-prev], [data-gr-placement-next]');
    if (!control) return;
    const section = control.closest('.gr-placement');
    const carousel = section ? section.querySelector('[data-gr-placement-carousel]') : null;
    if (!carousel) return;
    const direction = control.matches('[data-gr-placement-next]') ? 1 : -1;
    moveGoneRunaPlacement(carousel, direction);
  });

  document.querySelectorAll('[data-gr-placement-carousel]').forEach(startGoneRunaPlacement);
  document.addEventListener('shopify:section:load', function(event) {
    startGoneRunaPlacement(event.target.querySelector('[data-gr-placement-carousel]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goneruna-product-hero"] && !Shopify.designMode) return;
  try {
    
  function getGoneRunaGalleryIndex(gallery) {
    const slides = gallery.querySelectorAll('.gr-hero__media');
    if (!slides.length || !gallery.clientWidth) return 0;
    return Math.max(0, Math.min(slides.length - 1, Math.round(gallery.scrollLeft / gallery.clientWidth)));
  }

  function goToGoneRunaGallery(gallery, index) {
    const slides = gallery.querySelectorAll('.gr-hero__media');
    if (!slides.length) return;
    const wrappedIndex = ((index % slides.length) + slides.length) % slides.length;
    gallery.scrollTo({ left: gallery.clientWidth * wrappedIndex, behavior: wrappedIndex === index ? 'smooth' : 'auto' });
  }

  function updateGoneRunaGallery(gallery) {
    const section = gallery.closest('.gr-hero');
    if (!section) return;
    const current = getGoneRunaGalleryIndex(gallery);
    const currentLabel = section.querySelector('[data-gr-gallery-current]');
    if (currentLabel) currentLabel.textContent = current + 1;
    section.querySelectorAll('[data-gr-gallery-thumb]').forEach(function(thumbnail, index) {
      thumbnail.setAttribute('aria-current', index === current ? 'true' : 'false');
      if (index === current) thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    });
  }

  document.addEventListener('click', function(event) {
    const control = event.target.closest('[data-gr-gallery-prev], [data-gr-gallery-next], [data-gr-gallery-thumb]');
    if (!control) return;
    const section = control.closest('.gr-hero');
    const gallery = section ? section.querySelector('[data-gr-gallery]') : null;
    if (!gallery) return;
    if (control.matches('[data-gr-gallery-thumb]')) {
      goToGoneRunaGallery(gallery, Number(control.dataset.grGalleryIndex));
      return;
    }
    const direction = control.matches('[data-gr-gallery-next]') ? 1 : -1;
    goToGoneRunaGallery(gallery, getGoneRunaGalleryIndex(gallery) + direction);
  });

  document.addEventListener('touchstart', function(event) {
    const gallery = event.target.closest ? event.target.closest('[data-gr-gallery]') : null;
    if (gallery && event.touches.length === 1) {
      gallery.dataset.grTouchStart = event.touches[0].clientX;
      gallery.dataset.grTouchStartIndex = getGoneRunaGalleryIndex(gallery);
    }
  }, { passive: true });

  document.addEventListener('touchend', function(event) {
    const gallery = event.target.closest ? event.target.closest('[data-gr-gallery]') : null;
    if (!gallery || !gallery.dataset.grTouchStart || !event.changedTouches.length) return;
    const delta = event.changedTouches[0].clientX - Number(gallery.dataset.grTouchStart);
    const startIndex = Number(gallery.dataset.grTouchStartIndex);
    delete gallery.dataset.grTouchStart;
    delete gallery.dataset.grTouchStartIndex;
    const slides = gallery.querySelectorAll('.gr-hero__media');
    if (delta < -40 && startIndex === slides.length - 1) goToGoneRunaGallery(gallery, 0);
    if (delta > 40 && startIndex === 0) goToGoneRunaGallery(gallery, slides.length - 1);
  }, { passive: true });

  document.addEventListener('keydown', function(event) {
    const gallery = event.target.closest ? event.target.closest('[data-gr-gallery]') : null;
    if (!gallery || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
    event.preventDefault();
    goToGoneRunaGallery(gallery, getGoneRunaGalleryIndex(gallery) + (event.key === 'ArrowRight' ? 1 : -1));
  });

  document.addEventListener('scroll', function(event) {
    const gallery = event.target.closest ? event.target.closest('[data-gr-gallery]') : null;
    if (gallery) window.requestAnimationFrame(function() { updateGoneRunaGallery(gallery); });
  }, true);

  document.addEventListener('change', function(event) {
    const input = event.target.closest('[data-gr-variant]');
    if (!input) return;
    const section = input.closest('.gr-hero');
    if (!section) return;
    const price = section.querySelector('[data-gr-price]');
    const mobilePrice = section.querySelector('[data-gr-mobile-price]');
    const compare = section.querySelector('[data-gr-compare]');
    if (price) price.textContent = input.dataset.price;
    if (mobilePrice) mobilePrice.textContent = input.dataset.price;
    if (compare) { compare.textContent = input.dataset.compare || ''; compare.classList.toggle('gr-hero__compare--hidden', !input.dataset.compare); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goneruna-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gr-review-loop')) {
    customElements.define('gr-review-loop', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-review-rail]');
        if (!this.rail) return;
        this.section = this.closest('.gr-reviews');
        this.section.dataset.ready = 'true';
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.mobile = window.matchMedia('(max-width: 800px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.pausedUntil = 0;
        this.manualPause = false;
        this.visible = false;
        this.originals = Array.from(this.rail.querySelectorAll('[data-review-card]'));
        this.pauseButton = this.querySelector('[data-review-pause]');
        this.pageSize = Number(this.dataset.pageSize) || 0;
        this.shown = this.pageSize || this.originals.length;
        this.loadButton = this.querySelector('[data-review-load]');
        this.updatePage = () => {
          this.originals.forEach((card,index) => { card.hidden = index >= this.shown; });
          this.loadButton.hidden = !this.pageSize || this.shown >= this.originals.length;
        };
        this.updatePage();
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.syncAnimation();
        });
        this.observer.observe(this);
        this.addEventListener('pointerdown', () => { this.pausedUntil = Date.now() + 6000; }, options);
        this.addEventListener('touchstart', () => { this.pausedUntil = Date.now() + 6000; }, { ...options, passive: true });
        this.addEventListener('wheel', () => { this.pausedUntil = Date.now() + 6000; }, { ...options, passive: true });
        this.addEventListener('focusin', () => { this.focused = true; }, options);
        this.addEventListener('focusout', () => { this.focused = false; this.pausedUntil = Date.now() + 1500; }, options);
        this.addEventListener('click', event => {
          if (event.target.closest('[data-review-load]')) {
            const firstNew = this.originals[this.shown];
            this.shown = Math.min(this.shown + this.pageSize, this.originals.length);
            this.updatePage();
            this.setup();
            if (firstNew) { firstNew.setAttribute('tabindex','-1'); firstNew.focus({preventScroll:true}); }
            const status = this.querySelector('[data-review-status]');
            status.textContent = `${Math.min(this.shown,this.originals.length)} / ${this.originals.length}`;
          }
          const button = event.target.closest('[data-review-more]');
          if (button) {
            const card = button.closest('[data-review-card]');
            const expanded = button.getAttribute('aria-expanded') !== 'true';
            this.rail.querySelectorAll('[data-review-card]').forEach(item => {
              if (item.dataset.reviewKey !== card.dataset.reviewKey) return;
              item.toggleAttribute('data-expanded', expanded);
              const control = item.querySelector('[data-review-more]');
              control.setAttribute('aria-expanded', String(expanded));
              control.textContent = expanded ? control.dataset.less : control.dataset.more;
            });
          }
          if (event.target.closest('[data-review-pause]')) {
            this.manualPause = !this.manualPause;
            this.pauseButton.setAttribute('aria-pressed', String(this.manualPause));
            this.pauseButton.textContent = this.manualPause ? this.pauseButton.dataset.play : this.pauseButton.dataset.pause;
          }
        }, options);
        this.setup = () => {
          this.rail.querySelectorAll('[data-review-clone]').forEach(item => item.remove());
          this.cycle = 0;
          const overflow = this.originals.map(card => {
            const quote = card.querySelector('[data-review-quote]');
            const button = card.querySelector('[data-review-more]');
            return { button, hidden: !card.hidden && quote && button && !card.hasAttribute('data-expanded') && quote.scrollHeight <= quote.clientHeight + 2 };
          });
          overflow.forEach(({ button, hidden }) => { if (button) button.hidden = hidden; });
          const enabled = this.section.classList.contains('gr-reviews--compact') && this.dataset.autoplay === 'true' && this.originals.length > 1;
          this.pauseButton.hidden = !enabled || this.reduced.matches;
          if (!enabled) { this.syncAnimation(); return; }
          this.originals.forEach(card => {
            const clone = card.cloneNode(true);
            clone.dataset.reviewClone = 'true';
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            clone.querySelectorAll('button, a, input').forEach(item => item.setAttribute('tabindex', '-1'));
            this.rail.appendChild(clone);
          });
          this.cycle = this.rail.querySelector('[data-review-clone]').offsetLeft - this.originals[0].offsetLeft;
          this.syncAnimation();
        };
        this.mobile.addEventListener('change', this.setup, options);
        this.reduced.addEventListener('change', this.setup, options);
        window.addEventListener('resize', this.setup, options);
        document.fonts.ready.then(() => { if (this.isConnected) this.setup(); });
        this.tick = time => {
          this.frame = null;
          const delta = Math.min(time - (this.lastTime || time), 50);
          this.lastTime = time;
          if (this.cycle && this.visible && !this.reduced.matches && !document.hidden && !this.manualPause && !this.focused && Date.now() >= this.pausedUntil && !this.querySelector('[data-expanded]')) {
            this.distance = (this.distance || 0) + delta * .016;
            const step = Math.floor(this.distance);
            this.distance -= step;
            if (step) {
              const next = this.rail.scrollLeft + step;
              this.rail.scrollLeft = next >= this.cycle ? next - this.cycle : next;
            }
          }
          this.syncAnimation();
        };
        document.addEventListener('visibilitychange', () => this.syncAnimation(), options);
        this.setup();
      }
      syncAnimation() {
        const active = this.isConnected && this.visible && this.cycle && !this.reduced.matches && !document.hidden;
        if (!active) {
          cancelAnimationFrame(this.frame);
          this.frame = null;
          this.lastTime = null;
        } else if (this.frame == null && this.tick) {
          this.frame = requestAnimationFrame(this.tick);
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.lastTime = null;
        this.controller?.abort();
        this.observer?.disconnect();
        this.querySelectorAll('[data-review-clone]').forEach(item => item.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goneruna-timeline"] && !Shopify.designMode) return;
  try {
    
  function activateGoneRunaTimelineTab(tab) {
    const section = tab.closest('.gr-timeline');
    if (!section) return;
    section.querySelectorAll('[data-gr-timeline-tab]').forEach(function(candidate) {
      const selected = candidate === tab;
      candidate.setAttribute('aria-selected', selected ? 'true' : 'false');
      candidate.setAttribute('tabindex', selected ? '0' : '-1');
      const panel = section.querySelector('#' + candidate.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
  }

  document.addEventListener('click', function(event) {
    const tab = event.target.closest('[data-gr-timeline-tab]');
    if (tab) activateGoneRunaTimelineTab(tab);
  });

  document.addEventListener('keydown', function(event) {
    const tab = event.target.closest('[data-gr-timeline-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    const tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('[data-gr-timeline-tab]'));
    const current = tabs.indexOf(tab);
    const offset = event.key === 'ArrowRight' ? 1 : -1;
    const next = tabs[(current + offset + tabs.length) % tabs.length];
    event.preventDefault();
    activateGoneRunaTimelineTab(next);
    next.focus();
  });

  document.addEventListener('shopify:block:select', function(event) {
    const tab = event.target.matches('[data-gr-timeline-tab]') ? event.target : event.target.querySelector('[data-gr-timeline-tab]');
    if (tab) activateGoneRunaTimelineTab(tab);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["runa-real-results"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('runa-results'))customElements.define('runa-results',class extends HTMLElement{
 connectedCallback(){
  this.controller=new AbortController();
  const options={signal:this.controller.signal};
  this.rail=this.querySelector('.rs-review-grid');
  this.cards=Array.from(this.querySelectorAll('[data-review-category]'));
  this.categories=Array.from(this.querySelectorAll('[data-category]'),button=>button.dataset.category);
  this.mobile=window.matchMedia('(max-width:750px)');
  this.category=this.categories[0];
  this.select(this.category,false);
  this.addEventListener('click',event=>{
   const button=event.target.closest('[data-category]');
   if(button&&this.contains(button))this.select(button.dataset.category);
   const arrow=event.target.closest('[data-review-direction]');
   if(arrow&&this.contains(arrow)){
    const index=this.categories.indexOf(this.category);
    this.select(this.categories[(index+Number(arrow.dataset.reviewDirection)+this.categories.length)%this.categories.length]);
   }
  },options);
  this.rail.addEventListener('scroll',()=>{
   if(!this.mobile.matches)return;
   cancelAnimationFrame(this.scrollFrame);
   this.scrollFrame=requestAnimationFrame(()=>{
    const left=this.rail.getBoundingClientRect().left;
    const visible=this.cards.filter(card=>!card.hidden);
    const nearest=visible.reduce((best,card)=>!best||Math.abs(card.getBoundingClientRect().left-left)<Math.abs(best.getBoundingClientRect().left-left)?card:best,null);
    if(nearest)this.mark(nearest.dataset.reviewCategory);
   });
  },{...options,passive:true});
  this.mobile.addEventListener('change',()=>this.select(this.category,false),options);
  document.addEventListener('shopify:block:select',event=>{
   const card=event.target.closest('[data-review-category]');
   if(card&&this.contains(card)){
    this.select(card.dataset.reviewCategory,false);
    if(this.mobile.matches)this.jump(card,false);
   }
  },options);
 }
 mark(category){
  this.category=category;
  this.querySelectorAll('[data-category]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.category===category)));
 }
 jump(card,smooth){
  const left=card.getBoundingClientRect().left-this.rail.getBoundingClientRect().left+this.rail.scrollLeft;
  this.rail.scrollTo({left,behavior:smooth&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});
 }
 select(category,smooth=true){
  this.mark(category);
  let count=0;
  this.cards.forEach(card=>{
   const match=card.dataset.reviewCategory===category;
   card.hidden=this.mobile.matches?!this.categories.includes(card.dataset.reviewCategory):!match||count>=3;
   if(match&&!card.hidden)count++;
  });
  this.querySelector('.rs-empty').hidden=this.mobile.matches?this.cards.some(card=>!card.hidden):count>0;
  if(this.mobile.matches){
   const first=this.cards.find(card=>card.dataset.reviewCategory===category&&!card.hidden);
   if(first)this.jump(first,smooth);
  }else this.rail.scrollLeft=0;
 }
 disconnectedCallback(){this.controller?.abort();cancelAnimationFrame(this.scrollFrame);}
});

  } catch(e) { console.error(e); }
})();
})();
